// Tum fetch cagrilarini sarar (uygulama acilisinda bir kez kurulur):
//  - Sunucu X-Refreshed-Token gonderirse oturum yenilenir (kayan oturum) ve
//    eklentiye de iletilir. Paneli kullanan kisi atilmaz.
//  - Token gercekten dolmussa (401 INVALID_TOKEN) oturum temizlenip giris
//    sayfasina yonlendirilir; islemler anlasilmaz hatayla bitmez.

import { getBackendUrl } from "./http";
import { sendTokenToExtension } from "./extension";

let installed = false;
let redirecting = false;

export function installSessionFetch() {
  if (installed || typeof window === "undefined") return;
  installed = true;
  const orig = window.fetch.bind(window);
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const res = await orig(input, init);
    try {
      const url = typeof input === "string" ? input : input instanceof URL ? input.href : input.url;
      const api = getBackendUrl();
      const ours = url.startsWith(api) || url.startsWith("/api/");
      if (!ours) return res;

      const fresh = res.headers.get("X-Refreshed-Token");
      if (fresh) {
        const expiresAt = res.headers.get("X-Refreshed-Expires") ?? undefined;
        localStorage.setItem("erc_token", fresh);
        try {
          const raw = localStorage.getItem("erc_session");
          if (raw) {
            const sess = JSON.parse(raw) as Record<string, unknown>;
            localStorage.setItem("erc_session", JSON.stringify({ ...sess, token: fresh, ...(expiresAt ? { expiresAt } : {}) }));
          }
        } catch { /* bozuk oturum kaydi */ }
        void sendTokenToExtension(fresh).catch(() => {});
      }

      if (res.status === 401 && !redirecting && !url.includes("/api/auth/")) {
        // Sunucu bicimi: { error: "INVALID_TOKEN", message: "Gecersiz veya suresi dolmus token" }
        const body = await res.clone().json().catch(() => ({})) as { code?: string; error?: unknown; message?: string };
        const code = typeof body.error === "string" ? body.error : (body.error as { code?: string } | undefined)?.code ?? body.code;
        if (code === "INVALID_TOKEN" || /suresi dolmus token/i.test(body.message ?? "")) {
          redirecting = true;
          localStorage.removeItem("erc_token");
          localStorage.removeItem("erc_session");
          const back = encodeURIComponent(window.location.pathname + window.location.search);
          window.location.href = `/login?expired=1&next=${back}`;
        }
      }
    } catch { /* sarmalayici hic bir zaman istegi bozmasin */ }
    return res;
  };
}
